import "core-js/modules/es.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { validationMixin } from "vuelidate";

var _require = require("vuelidate/lib/validators"),
    required = _require.required;

export default {
  data: function data() {
    return {
      selectOptions: ["", "Option1", "Option2", "Option3", "Option4", "Option5"],
      name: "",
      rank: "",
      select: "",
      detail: "",
      customRadio: "",
      customCheckbox: []
    };
  },
  mixins: [validationMixin],
  validations: {
    name: {
      required: required
    },
    rank: {
      required: required
    },
    select: {
      required: required
    },
    detail: {
      required: required
    },
    customRadio: {
      required: required
    },
    customCheckbox: {
      required: required
    }
  },
  methods: {
    onValitadeFormSubmit: function onValitadeFormSubmit() {
      this.$v.$touch();
      console.log(JSON.stringify({
        name: this.name,
        rank: this.rank,
        select: this.select,
        detail: this.detail,
        customRadio: this.customRadio,
        customCheckbox: this.customCheckbox
      }));
    }
  }
};